export default __webpack_public_path__ + "static/media/icon-audio-off.686cc2a6.svg";